module.exports = [{
      plugin: require('/mnt/c/Users/Samuel Monteiro/Documents/samuel-blog/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/mnt/c/Users/Samuel Monteiro/Documents/samuel-blog/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
